<template>
    <div class="gold-server-container" v-on:click="goToLink()">
        <div class="gold-server-content-container">
            <v-avatar size="40" tile style="margin-right: 1rem;">
                <img :src="image" alt="alt">
            </v-avatar>

            <div class="gold-server-text-container">
                <h3>{{title}}</h3>
                <p>{{description}}</p>
            </div>
        </div>
        
        <!-- TODO: v-if desktop-->
        <div class="gold-server-desktop-content-container">
            <h3>{{title}}</h3>
            <img :src="image" alt="alt" style="height: 76px; width: 76px;">
            <p style="font-size: 14px; width: 100%; text-align: center;">{{description}}</p>
        </div>

    </div>
</template>


<script>
export default {
    name: 'GoldServer',

    props: {
        title: String,
        description: String,
        image: String,
        url: String,
    },

    methods: {
        goToLink: function () {
            window.open(this.url)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        font-size: 16px;
        margin: 0;
    }

    p {
        font-size: 12px;
        margin: 0;
    }

    span {
        font-size: 10px;
    }

    .gold-server-container {
        height: 70px;
        width: 80%;

        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        padding: 0 16px;
        box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
        border-radius: 5px;

        background-color: #404040;
        margin-bottom: 1rem;

        cursor: pointer;
    }

    .gold-server-content-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        overflow-x: hidden;
        text-overflow: clip;
    }

    .gold-server-text-container {
        min-width: 100%;
    }

    .gold-server-desktop-content-container {
        display: none;
    }

    @media screen and (min-width: 1000px) {

        .gold-server-content-container {
            display: none;
        }

        .gold-server-container {
            height: 200px;

            width: 100%;

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            padding: 16px;
        }

        .gold-server-desktop-content-container {
            height: 100%;

            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            margin-bottom: 10px;
        }
    }
</style>
